import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=0bb49bed&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=0bb49bed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb49bed",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bb49bed')) {
      api.createRecord('0bb49bed', component.options)
    } else {
      api.reload('0bb49bed', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=0bb49bed&scoped=true&", function () {
      api.rerender('0bb49bed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2SZV0qQX7VOVf/JS/comp/CookieBox.vue"
export default component.exports